import { render, staticRenderFns } from "./dlg_NotAccount.vue?vue&type=template&id=0e368c52"
import script from "./dlg_NotAccount.vue?vue&type=script&lang=js"
export * from "./dlg_NotAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports